import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRCodeGenerator = ({ data, size = 64, className = "" }) => {
  const [qrCodeDataURL, setQrCodeDataURL] = useState('');

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        if (!data) return;
        
        // Generate QR code as data URL
        const dataURL = await QRCode.toDataURL(data, {
          width: size,
          height: size,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        
        setQrCodeDataURL(dataURL);
      } catch (error) {
        console.error('Error generating QR code:', error);
        // Fallback to external service if local generation fails
        const fallbackURL = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(data)}&size=${size}x${size}`;
        setQrCodeDataURL(fallbackURL);
      }
    };

    generateQRCode();
  }, [data, size]);

  if (!qrCodeDataURL) {
    return (
      <div 
        className={`bg-gray-200 flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <span className="text-xs text-gray-500">QR</span>
      </div>
    );
  }

  return (
    <img
      src={qrCodeDataURL}
      alt="QR Code"
      className={className}
      style={{ width: size, height: size }}
    />
  );
};

export default QRCodeGenerator;